export const AUTH_TYPES = Object.freeze({
  OAUTH2: 'oAuth2',
  CREDENTIALS: 'credentials',
  CUSTOM: 'custom',
})
